export enum DepositStatus {
  ACTIVE = 'ACTIVE',
  MATURED = 'MATURED',
}
